<template>
    <main>
      <div class="main-screen topspace"  :style="{ backgroundImage: 'url(' + image + ')' }">
        <div class="center-wrap">
          <v-popover
            offset="8"
            placement="right"
          >
            <div class="main-screen__wrap">
              <h4>Engineering progress</h4>
              <h4>Enhancing lives</h4>
              <h1>{{ mainheader }}</h1>
              <br/>
              <h2>{{ header1 }}</h2>
              <h2>{{ header2 }}</h2>
              <h2>{{ header3 }}</h2>
              <br/>
              <div class="main-screen__line"><div class="main-screen__line-fill"></div></div>
              <br/><br/>
              <img class="main-screen__logo" :src="logoimage" border="0">
            </div>
            <template slot="popover">
              <h3 class="popover-header">Инженерные системы</h3>
              <div class="popover-body">Инженерные системы состоят из компонентов и установки. Компоненты произведены в Германии, устанавливает специалист, сертифицированный REHAU.</div>
            </template>
          </v-popover>
        </div>
      </div>
    </main>
</template>
<script>

  export default {
    props: ['image', 'mainheader', 'header1', 'header2', 'header3'],
    bodyClass: "about-us",
    computed: {
    },
    data () {
      return {
        logoimage: require("@/assets/img/rmain/logo5.svg")
      }
    }
  }
</script>
<style lang="scss" scoped>
@import "@/assets/scss/material-kit/_colors.scss";


$mb: 80px;
$mbt: 30px;


.abtn {
  height: 36px !important;
}

div.center-wrap {
	max-width: 1140px;
    padding-left: 15px;
    padding-right: 15px;
    width: 100%;
    margin: 0px auto;
}

.topspace {
  padding-top: 170px;
}

* {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
}

h1,h2,h3,h4,h5,p {
  margin: 0px;
}

h2 {
  font-size: 36px;
  font-weight: 500;
  text-align: center;
  text-transform: uppercase;
}


.main-screen {
  margin-top: 70px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding-top: 600px;
  div.center-wrap {
    display: flex;
  }

  &__logo {
    position: absolute;
    width: 150px;
    right: 10px;
    bottom: 0px;
  }

  &__line {
    position: absolute;
    bottom: 60px;
    left: -100px;
    height: 8px;
    background-color: #000;
    min-width: 160px;
    margin-bottom: 5px;
    &-fill {
      width: 100px;
      background: #fff;
      height: 100%;
    }
  }

  &__wrap {
		position: absolute;
		right: calc( ( 100% - 1100px ) / 2 );
		background: #fff;
		padding: 35px;
    padding-right: 50px;
    top: 150px;
    h1 {
			font-weight: 500;
			font-size: 18pt;
			color: black;
			padding-top: 30px;
			line-height: 1.15em;
      text-transform: uppercase;
    }
    h2 {
			font-weight: 300;
			font-size: 14pt;
			color: black;
			padding-top: 5px;
      line-height: 1.15em;
      text-align: left;
    }
    h4 {
			font-weight: 500;
			font-size: 12pt;
			color: black;
			padding-top: 0px;
			line-height: 1.15em;
    }

    p {
      font-size: 20px;
       font-weight: 400;
       margin-top: 20px;
    }
  }

  &__bottom {
    min-height: 101px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}


@media screen {
    .main-screen__wrap {
        margin-left: 0;
        cursor: pointer;
    }
}

@media screen and ( max-width: 1366px ) {
    .main-screen {
        margin-top: 50px;
        background-size: 150%;
        background-position: 0% 40%;
    }

    .main-screen__wrap {
    		right: calc( ( 100% - 1000px ) / 2 );
        margin-top: 10px !important;
        margin-left: 0;
    }
}

@media screen and ( max-width: 830px ) {
    .main-screen {
        margin-top: 50px;
        background-size: 180%;
        background-position: 40% 0px;
        padding-top: 500px;
    }
    .main-screen__wrap {
    	right: calc( ( 100% - 700px ) / 2 );
      top: 50px;
    }
}


@media screen and ( max-width: 768px ) {
  .main-screen__wrap {
    top: 50px;
   	right: calc( ( 100% - 600px ) / 2 );
  }
  .main-screen__wrap h1 {
    font-size: 26px;
    line-height: 26px;
  }

  .main-screen__wrap p {
    font-size: 18px;
    margin-top: 15px;
  }

  .main-screen__wrap {
    padding-top: 30px;
    min-height: 194px !important;
    max-width: 335px !important;
  }
}

@media screen and ( max-width: 700px ) {
    .main-screen {
        margin-top: 0px !important;
        background-size: 130%;
        background-position: 99% 0px;
    } 
    .main-screen__wrap {
      margin-top: 30px !important;
      top: 30px;
    }
}

@media screen and ( max-width: 670px ) {
    .main-screen {
        background: none;
        margin-top: 0px;
    } 
    .main-screen__wrap {
      right: none;
      left: calc( ( 100% - 340px ) / 2 );
      margin-top: 10px !important;
      padding-top: 40px !important;
      min-height: 185px !important;
      max-width: 335px !important;
      padding-left: 20px !important;
      font-size: 16px !important;
    }
}

@media screen and ( max-width: 550px ) {
    .main-screen {
        background: none;
        margin-top: 0px;
    } 
    .main-screen__wrap {
      right: none;
      left: 10px;
      margin-top: 10px !important;
      padding-top: 40px !important;
      min-height: 185px !important;
      max-width: 335px !important;
      padding-left: 20px !important;
      font-size: 16px !important;
    }
}

@media screen and ( max-width: 480px ) {
    .main-screen {
        background: none;
        margin-top: 0px;
    } 
    .main-screen__wrap {
      right: none;
      left: 10px;
      margin-top: 10px !important;
      padding-top: 40px !important;
      min-height: 185px !important;
      max-width: 335px !important;
      padding-left: 20px !important;
      font-size: 16px !important;
    }
      
}
</style>
